import { slideWrapper } from './slide';
import React from 'react';
import { TextBox } from './text-box';
import { Content } from './content';
import { Text } from './text';
import { useRoundSummary } from '../hooks/use-round-summary';
import { DisplayScore } from './display-score';
import firebase from 'firebase/app';
import { useEffect } from 'react';
import { SESSION_PUBLIC_COLLECTION } from '@disco/data';

export const GameSummary = slideWrapper(({ data, step, getImg }) => {
  const { title, type } = step;
  const { sessionId, sessionCode } = data;

  const { summaryData } = useRoundSummary({ sessionId, type });

  const groups = summaryData?.length
    ? summaryData.map((ele) => ({
        groupName: ele.groupName,
        text: ele?.groupNickname || ele.groupName,
        score: ele.hours,
      }))
    : [];

  const maxHours = type?.includes('leonardo') ? 48 : 72;

  useEffect(() => {
    if (!summaryData.length) return;
    firebase
      .firestore()
      .collection(SESSION_PUBLIC_COLLECTION)
      .doc(sessionCode)
      .set({ groupScores: groups, maxHours }, { merge: true });
  }, [summaryData]);

  return (
    <>
      <Content top={16}>
        <TextBox>{title}</TextBox>
      </Content>
      <Content width="100%" top={55}>
        <DisplayScore {...{ groups, getImg, maxHours }} />
      </Content>
    </>
  );
});
